var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSemester(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1465 7.49994H23.6465V5.99998C23.6465 5.46409 23.3605 4.96884 22.8965 4.70089C22.4324 4.43304 21.8605 4.43304 21.3965 4.70089C20.9324 4.96888 20.6465 5.46414 20.6465 5.99998V7.49994H9.39644V5.99998C9.39644 5.46409 9.11054 4.96884 8.64644 4.70089C8.18238 4.43304 7.6105 4.43304 7.14644 4.70089C6.68238 4.96888 6.39644 5.46414 6.39644 5.99998V7.49994H4.89644C4.59816 7.49994 4.31187 7.61848 4.10095 7.82942C3.89005 8.04037 3.77148 8.32665 3.77148 8.62494V22.875C3.77148 23.1733 3.89001 23.4596 4.10095 23.6705C4.31187 23.8814 4.59816 24 4.89644 24V24.375C4.88727 24.6625 4.99206 24.9421 5.18808 25.1527C5.38394 25.3635 5.65514 25.4882 5.94276 25.4999H24.1C24.3877 25.4882 24.6589 25.3635 24.8547 25.1527C25.0507 24.9421 25.1556 24.6625 25.1464 24.375V24C25.4447 24 25.731 23.8814 25.9419 23.6705C26.1528 23.4595 26.2713 23.1732 26.2713 22.875V8.62494C26.2713 8.32661 26.1528 8.04032 25.9419 7.82942C25.7309 7.61852 25.4446 7.49994 25.1464 7.49994H25.1465ZM25.5215 22.875C25.5215 22.9744 25.482 23.0698 25.4116 23.1402C25.3413 23.2105 25.2459 23.25 25.1465 23.25H4.89644C4.68936 23.25 4.52144 23.0821 4.52144 22.875V8.62494C4.52144 8.41785 4.68936 8.24994 4.89644 8.24994H6.39644V8.99994C6.39644 9.53582 6.68238 10.031 7.14644 10.299C7.6105 10.5669 8.18238 10.5669 8.64644 10.299C9.1105 10.031 9.39644 9.53578 9.39644 8.99994V8.24994H20.6465V8.99994C20.6465 9.53582 20.9324 10.031 21.3965 10.299C21.8605 10.5669 22.4324 10.5669 22.8965 10.299C23.3605 10.031 23.6465 9.53578 23.6465 8.99994V8.24994H25.1465C25.2459 8.24994 25.3413 8.28945 25.4116 8.35978C25.482 8.43011 25.5215 8.52551 25.5215 8.62494V22.875Z",
    fill: "url(#paint0_linear_5555_84516)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1465 16.1249V14.0474L15.4715 15.6562C15.1846 15.7814 14.8584 15.7814 14.5715 15.6562L10.8965 14.0474V16.1249C10.8963 16.2786 10.9899 16.4169 11.1327 16.4737L14.8827 17.9737C14.9718 18.0092 15.0712 18.0092 15.1603 17.9737L18.9103 16.4737C19.0531 16.4169 19.1467 16.2786 19.1465 16.1249Z",
    fill: "url(#paint1_linear_5555_84516)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64648 18.75H8.64648C8.85357 18.75 9.02148 18.9571 9.02148 19.125V22.125C9.02148 22.3321 8.85357 22.5 8.64648 22.5H5.64648C5.4394 22.5 5.27148 22.2929 5.27148 22.125V19.125C5.27148 18.9179 5.4394 18.75 5.64648 18.75Z",
    fill: "url(#paint2_linear_5555_84516)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8965 18.75H13.8965C14.1036 18.75 14.2715 18.9571 14.2715 19.125V22.125C14.2715 22.3321 14.1036 22.5 13.8965 22.5H10.8965C10.6894 22.5 10.5215 22.2929 10.5215 22.125V19.125C10.5215 18.9179 10.6894 18.75 10.8965 18.75Z",
    fill: "#F6AD55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1465 18.75H19.1465C19.3536 18.75 19.5215 18.9571 19.5215 19.125V22.125C19.5215 22.3321 19.3536 22.5 19.1465 22.5H16.1465C15.9394 22.5 15.7715 22.2929 15.7715 22.125V19.125C15.7715 18.9179 15.9394 18.75 16.1465 18.75Z",
    fill: "url(#paint3_linear_5555_84516)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3965 18.75H24.3965C24.6036 18.75 24.7715 18.9571 24.7715 19.125V22.125C24.7715 22.3321 24.6036 22.5 24.3965 22.5H21.3965C21.1894 22.5 21.0215 22.2929 21.0215 22.125V19.125C21.0215 18.9179 21.1894 18.75 21.3965 18.75Z",
    fill: "url(#paint4_linear_5555_84516)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87156 12.345L14.8716 14.97C14.9671 15.0117 15.0759 15.0117 15.1716 14.97L21.1716 12.345C21.3099 12.286 21.3996 12.1503 21.3996 12C21.3996 11.8496 21.3099 11.7139 21.1716 11.6549L15.1716 9.02993C15.0759 8.98823 14.9671 8.98823 14.8716 9.02993L8.87156 11.6549C8.73326 11.7139 8.64355 11.8496 8.64355 12C8.64355 12.1503 8.73326 12.286 8.87156 12.345Z",
    fill: "url(#paint5_linear_5555_84516)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5555_84516",
    x1: 3.77148,
    y1: 25.4999,
    x2: 28.6473,
    y2: 22.1514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ACF8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75EDA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5555_84516",
    x1: 10.8965,
    y1: 16.0238,
    x2: 19.1465,
    y2: 16.0238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414345"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5555_84516",
    x1: 5.27148,
    y1: 20.625,
    x2: 9.02148,
    y2: 20.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC008C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC6767"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5555_84516",
    x1: 15.7715,
    y1: 22.5,
    x2: 19.927,
    y2: 21.9779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ACF8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75EDA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5555_84516",
    x1: 24.6221,
    y1: 18.875,
    x2: 21.0226,
    y2: 22.6636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5FECA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283155,
    stopColor: "#3EDCEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623976,
    stopColor: "#2594FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5533FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5555_84516",
    x1: 8.64355,
    y1: 12,
    x2: 21.3996,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#928DAB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSemester);
export default __webpack_public_path__ + "static/media/Semester.91446e1ed4403237f80afcc9dcc02ed8.svg";
export { ForwardRef as ReactComponent };